{
  "title": "Widogast's Web of Fire (HB)",
  "source": "Critical Role (Twitter)",
  "levelAndSchool": "4th-level evocation",
  "level": 4,
  "castingTime": "1 action",
  "range": "60 ft",
  "components": "V, S, M (A cat's cradle of thread or string coated in phosphorus)",
  "duration": "Instantaneous",
  "description": [
    "Striking both palms down upon the ground, a web of flame crackles out around the caster and five streaks of fire rapidly snake along the ground toward up to five enemies the caster can see within a range of 60 feet, leaping towards their target and exploding into a column of flame upon reaching them. Each target must make a Dexterity saving throw, taking 8d6 fire damage on a failed save, or half as much damage on a successful one.",
    "Alternatively, all five streaks of fire can instead converge toward a single target, dealing 12d6 fire damage on a failed save, or half as much damage on a successful one.",
    "The fire can travel over obstacles up to 5 feet high, and ignites flammable objects along its path that aren't being worn or carried.",
    "At Higher Levels. When you cast this spell using a spell slot of 5th level or higher, the damage increases by 1d6 for each slot level above 4th."
  ],
  "spellLists": ["eldritch-knight", "wizard"]
}
